import {
  AssignmentTurnedInOutlined,
  CalendarTodayOutlined,
  LinkOutlined,
  PersonOutlineOutlined,
} from '@mui/icons-material';
import {
  getFirmDocumentReferenceLabels,
  getFirmDocumentRequestedFileLabels,
  getFirmDocumentUploadedByLabel,
  getFirmDocumentUploadedDateLabel,
} from 'pages/Documents/FirmDocuments/utilities';
import {
  FIRM_DOCUMENT_PREVIEW_IMAGE_FILE_TYPES,
  FIRM_DOCUMENT_PREVIEW_SPREADSHEET_FILE_TYPES,
  FIRM_DOCUMENT_PREVIEW_TEXT_FILE_TYPES,
  FIRM_DOCUMENT_PREVIEWABLE_FILE_TYPES,
} from './FirmDocumentPreviewPanel.constants';
import type { FirmDocumentPreviewPanelProps } from './FirmDocumentPreviewPanel.props';
import type { FirmDocumentPreviewMetadataItem } from './FirmDocumentPreviewPanel.types';

export const getPreviewMetadataItems = (
  documentReference: FirmDocumentPreviewPanelProps['documentReference']
) => {
  const uploadedByLabel = getFirmDocumentUploadedByLabel(documentReference);
  const uploadedDateLabel = getFirmDocumentUploadedDateLabel(documentReference.file.uploaded_date);
  const referenceLabels = getFirmDocumentReferenceLabels(documentReference);
  const requestedFileLabels = getFirmDocumentRequestedFileLabels(documentReference);

  const metadataItems: Array<FirmDocumentPreviewMetadataItem | null> = [
    uploadedByLabel
      ? { icon: <PersonOutlineOutlined fontSize="inherit" />, key: 'source', label: 'Source', value: uploadedByLabel }
      : null,
    uploadedDateLabel
      ? { icon: <CalendarTodayOutlined fontSize="inherit" />, key: 'uploaded', label: 'Uploaded', value: uploadedDateLabel }
      : null,
    referenceLabels.length
      ? { icon: <LinkOutlined fontSize="inherit" />, key: 'references', label: 'References', value: referenceLabels.join(', ') }
      : null,
    requestedFileLabels.length
      ? {
        icon: <AssignmentTurnedInOutlined fontSize="inherit" />,
        key: 'requests',
        label: 'Requests',
        value: requestedFileLabels.join(', '),
      }
      : null,
  ];

  return metadataItems.filter((item): item is FirmDocumentPreviewMetadataItem => Boolean(item));
};

export const isFirmDocumentPreviewableFileType = (fileType?: string | null) => (
  Boolean(fileType && FIRM_DOCUMENT_PREVIEWABLE_FILE_TYPES.has(fileType))
);

export const isFirmDocumentImagePreviewFileType = (fileType?: string | null) => (
  Boolean(fileType && FIRM_DOCUMENT_PREVIEW_IMAGE_FILE_TYPES.has(fileType))
);

export const isFirmDocumentSpreadsheetPreviewFileType = (fileType?: string | null) => (
  Boolean(fileType && FIRM_DOCUMENT_PREVIEW_SPREADSHEET_FILE_TYPES.has(fileType))
);

export const isFirmDocumentTextPreviewFileType = (fileType?: string | null) => (
  Boolean(fileType && FIRM_DOCUMENT_PREVIEW_TEXT_FILE_TYPES.has(fileType))
);
